import React from "react"
import {Button, Table} from "react-bootstrap";

export default class AllPostsList extends React.Component {

    constructor(props) {
        super(props);
        const {posts} = props

        this.state = {
            posts: posts
        }
    }

    componentWillReceiveProps(nextProps) {
        const {posts} = nextProps
        this.setState({
            posts: posts
        });
    }

    render() {
        return <Table striped bordered hover size="sm">
            <thead>
            <tr>
                <th>Id</th>
                <th>Title</th>
                <th>Categories</th>
                {/*<th>Media</th>*/}
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            {this.state.posts.map((post, index) => {

                let idClassname = ''
                if (!post.isVisible) {
                    idClassname='lightGray'
                }

                let titleClassname = ''
                if (!post.isDisplayedTitle) {
                    titleClassname='lightGray'
                }

                let editButtonVariant = 'outline-primary'
                if (!post.isEdited){
                    editButtonVariant = 'outline-warning'
                }

                return <tr key={index}>
                    <td className={idClassname}>{post.id} {post.isVisible}</td>
                    <td className={titleClassname}>{post.title}</td>
                    <td>{
                        (post.categoryPosts.length > 0 ?
                            post.categoryPosts.map((category, index2) => {
                                return <div key={index2}>
                                    {category.category.name}
                                </div>
                            }) : '')
                    }</td>
                    {/*<td><img*/}
                    {/*    src={process.env.REACT_APP_API_URL + '/api/gagmedia_file_content/' + post.id}*/}
                    {/*    alt={post.name}*/}
                    {/*/></td>*/}
                    <td>
                        <Button variant={editButtonVariant} type="submit" data-postid={post.id} onClick={this.props.clickOnPost}>
                            Edit
                        </Button>
                    </td>
                </tr>
            })}
            </tbody>
        </Table>
    }
}